'use strict';
var CredentialListService = /** @class */ (function () {
    /*@ngInject*/
    function CredentialListService($http, $log, Util, Auth) {
        this.$http = $http;
        this.$log = $log;
        this.handleSuccess = Util.handleSuccess;
        this.handleError = Util.handleError;
        this.Auth = Auth;
    }
    CredentialListService.prototype.getDoctorTypes = function () {
        var request = this.$http.get('api/admin/doctortypes');
        return (request.then(this.handleSuccess, this.handleError));
    };
    /*@ngInject*/
    CredentialListService.prototype.getCredentials = function () {
        var _this = this;
        var request = this.$http.get('api/account/credentials');
        return (request.then(function (response) {
            var credList = [];
            var i, cred;
            if (response.status != 200 || (response.data && response.data.errors && response.data.errors.length)) {
                _this.handleError;
            }
            else {
                for (i in response.data.response.currentPage) {
                    cred = response.data.response.currentPage[i];
                    if (cred.prescribe == null && cred.dispense == null) {
                        credList.push(cred);
                    }
                }
            }
            return { status: response.status, data: credList };
            //return response.data.response;
        }, this.handleError));
    };
    CredentialListService.prototype.updateCredential = function (credential) {
        this.Auth.clearAccountCache();
        var self = this;
        return this.$http.put("api/account/credentials/" + credential.credentialId, credential)
            .then(function success(response) {
            if (response.status == 200) {
                self.$log.debug('success response.....', response);
            }
            else {
                self.$log.error('api returned other than 200 response.....', response);
            }
            return response;
        }, function error(response) {
            self.$log.error('error response.....', response);
            return response;
        });
    };
    CredentialListService.prototype.addCredential = function (credential) {
        this.Auth.clearAccountCache();
        var self = this;
        self.$log.debug('Adding this Crdential in service:', credential);
        return this.$http.post('api/account/credentials/', credential)
            .then(function success(response) {
            if (response.status == 200) {
                self.$log.debug('add credential success response.....', response);
            }
            else {
                self.$log.error('add credential returned other than 200 response.....', response);
            }
            return response;
        }, function error(response) {
            self.$log.error('add credential error response.....', response);
            return response;
        });
    };
    CredentialListService.prototype.deleteCredential = function (id) {
        this.Auth.clearAccountCache();
        var self = this;
        self.$log.debug('Deleting this Crdential in service:', id);
        return this.$http.delete("api/account/credentials/" + id)
            .then(function success(response) {
            if (response.status == 200) {
                self.$log.debug('delete credential success response.....', response);
            }
            else {
                self.$log.error('delete credential returned other than 200 response.....', response);
            }
            return response;
        }, function error(response) {
            self.$log.error('delete credential error response.....', response);
            return response;
        });
    };
    return CredentialListService;
}());
export default CredentialListService;
//# sourceMappingURL=credential-list.service.js.map